import { useCallback, useMemo, useState } from "react";
import { EncodeBookingResponseEnum, ivrApi } from "@b2bportal/ivr-api";
import { axiosInstance } from "@hopper-b2b/api";
import { BookingType } from "@hopper-b2b/types";

export const useHotelBookingSupportId = () => {
  const [supportId, setSupportId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchBookingSupportId = useCallback(async (bookingId: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const res = await ivrApi(axiosInstance).apiV0IvrEncodePost({
        bookingId,
        product: BookingType.Lodging,
      });
      if (
        res.data.EncodeBookingResponse === EncodeBookingResponseEnum.Success
      ) {
        setSupportId(res.data.encodedCode);
      } else {
        throw new Error("Failed to fetch booking support ID");
      }
      return res;
    } catch (err) {
      const error =
        err instanceof Error
          ? err
          : new Error("Failed to fetch booking support ID");
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return useMemo(
    () => ({
      supportId,
      isLoading,
      error,
      fetchBookingSupportId,
    }),
    [supportId, isLoading, error, fetchBookingSupportId]
  );
};
